import React from "react"

import * as contentDumpStyles from "../styles/ContentDump.module.css"

export default function ContentDump(props) {
  const { content } = props

  return (
    <>
      <div
        className={`container-fluid ${props.className} ${contentDumpStyles.wrapper}`}
      >
        <div className={`row g-0 justify-content-center`}>
          <div className={`col-12`}>
            <span
              dangerouslySetInnerHTML={{
                __html: content,
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}
